export default Object.freeze({
  NONE: null,
  UPLOAD: "upload",
  DELETE: "delete",
});
